import { addMinutes } from 'date-fns';
import { CarAllocation } from '../../../types/carAllocation';
import { joinDateStringAndTimeString } from '../../../services/joinDateStringAndTimeString';
import { snapToHalfHour } from './DayAllocations/allocationTableUtility';

export function isTimeInTask(
  time: Date,
  { workStartDate, workStartTime, taskEstimatedTime }: CarAllocation
): boolean {
  const startStr = joinDateStringAndTimeString(workStartDate, workStartTime);
  if (!startStr) return false;
  const startAt = snapToHalfHour(new Date(startStr));
  const endAt = addMinutes(startAt, taskEstimatedTime);
  return startAt <= time && time < endAt;
}
